// Honest ComingSoon for snapshot-create + restore (plan §B, deferred).
//
// "Snapshot current document" needs an Office.js doc-capture adapter (read the
// live Word doc → sections → `POST /{id}/snapshot`) and "Restore version N"
// needs an Office.js writer (`POST /revert-to-snapshot/{id}` → re-render
// sections into the doc) — both W2 adapters that do not exist yet and need a
// real-Word smoke. Rather than fake them with disabled buttons that imply a
// working flow, this is an explicit, honest placeholder. Deferred as
// F-VERSIONS-SNAPSHOT / F-VERSIONS-RESTORE.
//
// This is a thin LOCAL block (NOT the shell `<ComingSoon>`), mirroring
// `plan/OutlineComingSoon.tsx`: the shell component is a full-pane centered
// empty-state keyed by TabId; here we need a small sub-section inside the
// Versions pane. CLAUDE.md §9: logical utilities only, all strings via
// `t('versions.*')`. Dispatches nothing.

import { useTranslation } from 'react-i18next'

export function SnapshotComingSoon(): JSX.Element {
  const { t } = useTranslation()
  return (
    <div
      data-testid="versions-snapshot-coming-soon"
      className="border-t border-ink/10 px-3.5 py-4"
    >
      <div className="mb-2 text-[10px] font-bold uppercase tracking-wider text-ink/40">
        {t('versions.snapshot.header')}
      </div>
      <div className="flex flex-col items-center justify-center gap-2 px-4 py-6 text-center">
        <div className="font-serif text-sm font-semibold text-ink">
          {t('versions.snapshot.comingSoonTitle')}
        </div>
        <p className="max-w-[240px] text-xs leading-relaxed text-ink/60">
          {t('versions.snapshot.comingSoonBody')}
        </p>
      </div>
    </div>
  )
}
